import { InjectionToken, Provider } from '@angular/core';
import { CampaignsSegmentsApiService } from './campaigns-segments-api.service';
import { CampaignsSegmentsRepository } from './campaigns-segments.repository';

export const HTTP_CAMPAIGNS_SEGMENTS_SERVICE = new InjectionToken<CampaignsSegmentsRepository>('CampaignsSegmentsRepository');

export const CAMPAIGNS_SEGMENTS_API_PROVIDER: Provider = {
    provide: HTTP_CAMPAIGNS_SEGMENTS_SERVICE,
    useClass: CampaignsSegmentsApiService,
};
